import React from 'react';
import bglessLogo from '../../images/bglessLogo.png';
import './Loading.scss';

function Loading(props) {
    return (
        <div className='loadingPage'>
            <div className='loadingIconNInfo'>
                <img src={bglessLogo} alt="로딩중" />
                <div className='pArea'>
                    <p>데이터를 불러오는 중입니다.</p>
                    <p>잠시만 기다려 주세요</p>
                </div>
            </div>
        </div>
    );
}

export default Loading;